import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ProfileManagementService } from 'src/app/business/intelligencemgmt-ui/services/profile-management.service';

@Component({
  selector: 'app-hscode-mapping-dialog',
  templateUrl: './hscode-mapping-dialog.component.html',
  styleUrl: './hscode-mapping-dialog.component.less'
})
export class HscodeMappingDialogComponent implements OnInit {
  searchText: string = '';
  isLoading: boolean = false;
  allMappings: any[] = [];
  selectedMappingId: string = '';
  
  pageIndex: number = 1;
  pageSize: number = 10;
  totalMappings: number = 0;
  gotoPageNumber: number;
  maxPages: number = 0;
  
  sortKey: string = 'indicatorGroupCode,asc';

  constructor(
    @Inject(NZ_MODAL_DATA) public data: any,
    private modalRef: NzModalRef,
    private msg: NzMessageService,
    private profileMgtService: ProfileManagementService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.selectedMappingId = this.data?.selectedMappingId || '';
    this.loadHsCodeMappings();
  }

  /**
   * Load HS Code mappings from API with backend pagination and sorting
   */
  loadHsCodeMappings(): void {
    this.isLoading = true;

    this.profileMgtService.searchHsCodeMappingsByGroup(this.searchText, this.pageIndex - 1, this.pageSize, this.sortKey).subscribe({
      next: (response: any) => {
        this.allMappings = response?.content?.content || [];
        this.totalMappings = response?.content?.totalElements || 0;
        this.pageSize = response?.content?.size || 10;
        this.maxPages = response?.content?.totalPages || 0;
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error loading HS Code mappings:', error);
        this.isLoading = false;
        this.msg.error('Failed to load HS Code mappings');
        this.cdr.detectChanges();
      }
    });
  }

  /**
   * Handle search
   */
  onSearch(): void {
    this.pageIndex = 1;
    this.loadHsCodeMappings();
  }

  /**
   * Handle page change
   */
  onPageChange(page: number): void {
    this.pageIndex = page;
    this.loadHsCodeMappings();
  }

  /**
   * Go to specific page
   */
  goToPage(): void {
    if (this.gotoPageNumber && this.gotoPageNumber > 0 && this.gotoPageNumber <= this.maxPages) {
      this.pageIndex = this.gotoPageNumber;
      this.loadHsCodeMappings();
    }
  }

  /**
   * Handle mapping selection on row click
   */
  selectMapping(mapping: any): void {
    this.selectedMappingId = mapping.mappingId;
    this.modalRef.close(mapping);
  }

  /**
   * Handle sorting from table header
   */
  sort(sort: any): void {
    if (sort.key && sort.value) {
      sort.value = sort.value === 'descend' ? 'desc' : sort.value;
      sort.value = sort.value === 'ascend' ? 'asc' : sort.value;
      this.sortKey = sort.key + ',' + sort.value;
      this.pageIndex = 1;
      this.loadHsCodeMappings();
    }
  }

  /**
   * Close dialog without selection
   */
  closeDialog(): void {
    this.modalRef.close(null);
  }
}
